{
  "emptyState": {
    "title": "Denne skogeieren er ikke registrert som andelseier",
    "description": "Trykk på \"Registrer nytt andelseierskap\" for å starte registrering",
    "noPermissionDescription": "Du har ikke tilgang til å registrere andelseierskap.\n Opprettelse av andelseierskap må gjøres av en bruker med utvidet tilgang."
  },
  "generalInformation": {
    "forestownerAssociation": "Skogeierlag"
  },
  "changeShareOwnership": "Endre andelseierskap",
  "prductiveForest": "Produktiv skog",
  "registeredMembershipDate": "Registrert medlemskap",
  "registeredPartner": "Registrert partner",
  "shareOwnershipHolder": "Innehaver av andelseierskap",
  "registerNewShareOwnership": "Registrer nytt andelseierskap",
  "shareAccount": "Andelskonto",
  "shareCapital": "Andelskapital",
  "shareCapitalDescription": "Utregninger og status på andelskapital",
  "shareOwnershipInformation": "Andelsinformasjon",
  "shareOwnershipPreviouslyRegistered": "Andelseierskap har tidligere vært registrert på denne skogeieren",
  "reason": "Årsak",
  "deregistrationDate": "Avregistreringsdato",
  "shares": "Andeler",
  "requiredShareCapital": "Pliktig andelskapital",
  "paidShareCapital": "Innbetalt andelskapital",
  "owedShareCapital": "Skyldig andelskapital",
  "additionalCapital": "Tilleggskapital",
  "totalShareCapital": "Total andelskapital",
  "alerts": {
    "zeroSharesAlertTitle": "Ingen eiendommer er registrert på skogeieren. Handling kreves.",
    "dateForChange": "Dato for endring:",
    "addProperty": "Legg til ny eiendom",
    "endOwnership": "Avslutt andelseierskap"
  },
  "summary": {
    "obligatoryShareCapital": "Pliktig andelskapital",
    "owedShareCapital": "Skyldig andelskapital",
    "annualFee": "Serviceavgift",
    "annualFeeCurrent": "Serviceavgift i år",
    "notAvailable": "Ikke tilgjengelig"
  },
  "badges": {
    "shared": "Deles med partner",
    "transferable": "Overdras",
    "requiresDocumentation": "Må dokumenteres"
  }
}
